import api from './api';
import { API_ENDPOINTS } from '../config/api.config';

/**
 * Fetches positions from the API
 * @returns {Promise<Object>} Object containing positions data
 */
export const fetchPositions = async () => {
  try {
    const response = await api.get(API_ENDPOINTS.POSITIONS);
    return response.data;
  } catch (error) {
    console.error('Error fetching positions:', error);
    throw error;
  }
};

/**
 * Processes positions data from API or WebSocket
 * Handles two formats:
 * - API: {success: true, data: {open_positions: [], closed_positions: [], summary: {}}}
 * - WebSocket: {open_positions: [], closed_positions: [], summary: {}} (raw data)
 * @param {Object} data - The API response or WebSocket data
 * @returns {Object} Processed positions data with open and closed positions
 */
export const processPositionsData = (data) => {
  if (!data) {
    console.warn('[Positions] processPositionsData: no data provided');
    return { open: [], closed: [], summary: {} };
  }

  // Handle API format: {success: true, data: {...}}
  if (data.success !== undefined) {
    if (!data.success) {
      console.warn('[Positions] API returned success=false', {
        message: data?.message,
      });
      return { open: [], closed: [], summary: {} };
    }
    return {
      open: data.data?.open_positions || [],
      closed: data.data?.closed_positions || [],
      summary: data.data?.summary || {}
    };
  }

  // Handle WebSocket format: {open_positions: [], ...} (raw data)
  // WebSocket sends raw position analysis without success wrapper
  return {
    open: data.open_positions || [],
    closed: data.closed_positions || [],
    summary: data.summary || {}
  };
};